import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import preferences from "@coworker/enums/profilePreferences";
import { User } from "@sentry/react";
import useRolesMultiSelectFilter from "./useRolesMultiSelectFilter";

const useTeamsFilters = (users: User[], teamId: string) => {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.TEAMS_FILTERS
  );

  const useTeamsDataFilters = () => [
    useRolesMultiSelectFilter(true, users, true, teamId),
  ];

  const resetFilters = () => {
    setFilterValues([]);
  };

  return {
    useFiltersFactory: useTeamsDataFilters,
    filterValues,
    setFilterValues,
    resetFilters,
  };
};

export default useTeamsFilters;
